// src/internal/components/header/header-button.tsx
import * as React from "react";
import { styled } from "@mui/material/styles";
import { InternalButton, pseudo } from "@clara/ui";
import { jsx } from "react/jsx-runtime";
var StyledButton = styled(InternalButton)(({ theme }) => ({
  ...theme.typography.body2,
  padding: `${theme.space[1]} ${theme.space[2]}`,
  height: theme.space[8],
  minWidth: theme.space[8],
  color: theme.palette.v3.content.high_emphasis,
  flexShrink: 0,
  textAlign: "left",
  [pseudo._focusVisible]: {
    boxShadow: `0 0 0 2px ${theme.palette.v3.primary.outline}`
  },
  [pseudo._hover]: {
    background: "transparent",
    textDecoration: "underline",
    [pseudo._disabled]: {
      color: theme.palette.v3.content.low_emphasis,
      textDecoration: "none",
      boxShadow: "none"
    }
  },
  [pseudo._active]: {
    background: "transparent",
    boxShadow: `0 0 0 2px ${theme.palette.v3.primary.outline}`
  },
  [pseudo._disabled]: {
    color: theme.palette.v3.content.low_emphasis,
    textDecoration: "none",
    boxShadow: "none"
  }
}));
var HeaderButton = React.forwardRef(
  (props, ref) => {
    const { variant, leftIcon, ...rest } = props;
    const icon = leftIcon && React.cloneElement(leftIcon, {
      fontSize: "small"
    });
    return /* @__PURE__ */ jsx(
      StyledButton,
      {
        ref,
        ...rest,
        leftIcon: icon,
        iconSpacing: "0.25rem",
        variant: "ghost"
      }
    );
  }
);
HeaderButton.displayName = "HeaderButton";
var header_button_default = HeaderButton;

export {
  header_button_default
};
